import "./styles.css";
const container = document.querySelector(".container");
const messageContainer = document.querySelector(".message");
const resetButton = document.querySelector(".reset");
const winningOptions = [
  [0, 1, 2],
  [3, 4, 5],
  [6, 7, 8],
  [0, 3, 6],
  [1, 4, 7],
  [2, 5, 8],
  [0, 4, 8],
  [2, 4, 6],
];
let selected = ["", "", "", "", "", "", "", "", ""];
let player = "X";
let isGameOver;
function resetGame() {
  selected = ["", "", "", "", "", "", "", "", ""];
  player = "X";
  isGameOver = false;
  messageContainer.innerText = "";
  console.log(container.getElementsByClassName("item"));
  const items = container.querySelectorAll(".item");
  items.forEach((element) => {
    element.innerText = "";
  });
}
function checkGameStatus() {
  for (var option of winningOptions) {
    const cellA = selected[option[0]];
    const cellB = selected[option[1]];
    const cellC = selected[option[2]];
    if (cellA == "" || cellB == "" || cellC == "") {
      continue;
    }
    if (cellA == cellB && cellB == cellC) {
      isGameOver = true;
      break;
    }
  }
  if (isGameOver) {
    setBannerMessage(`Winner is ${player}`);
  } else if (!selected.includes("")) {
    setBannerMessage(`Draw`);
  } else {
    player = player == "X" ? "O" : "X";
    setBannerMessage(`${player} is your turn`);
  }
}
function setBannerMessage(message) {
  messageContainer.innerText = message;
}
function cellClick(e) {
  const selectedCell = e.target;
  if (!selectedCell.dataset.cell || isGameOver) {
    return;
  }
  selectedCell.innerText = player;
  selected[selectedCell.dataset.cell] = player;
  checkGameStatus();
}
function init() {
  container.addEventListener("click", cellClick);
  resetButton.addEventListener("click", resetGame);
}

init();
